module.exports = "mutation DeleteCampaign($id: ID!) {\n  deleteCampaign(id: $id) {\n    deleted\n  }\n}\n"